import React from 'react'

import {SkillGraph} from '../components'

export const AboutPage = () => {
  return <SkillGraph />
}
